// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__odwi-","requiredAsterisk":"Info_requiredAsterisk__2GXu3"};